import mergeStyles from './mergeStyles';
import reactBaseStyles from './reactBaseStyles';
export { mergeStyles };
export default reactBaseStyles;